import { H2 } from '@npco/zeller-design-system'
import styled from 'styled-components/macro'

export const StyledTransferComplete = styled.section`
  display: flex;
  align-items: center;
  padding: 2rem 1rem 4.5rem 1rem;
`

export const StyledCompleteIcon = styled.div`
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 1rem;
  background: ${({ theme }) => theme.colors.BLUE_80};
  line-height: 1;
`

export const StyledCompleteInfo = styled(H2)`
  color: ${({ theme }) => theme.colors.BLACK_900};
`
